export const getAppNotification = (payload) => {
  return {
    ...payload,
    id: payload.data?.info?.id || '',
    data: { ...(payload.data?.info || {}) },
  };
};
